import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../../../environments/environment";

@Injectable({
    providedIn: "root",
})
export class SendEmailService {
    constructor(private http: HttpClient) { }

    sendEmail(obj) {
        return this.http
            .post<any>(
                `${environment.smtpEmailUrl}SMTPEmail/Mail`,
                obj
            );
    }
    sendEmailFromSystem(obj) {
        return this.http
            .post<any>(
                `${environment.smtpEmailUrl}SendMail`,
                obj
            );
    }
}
